'use client';

import { ComponentProps, useMemo } from 'react';
import NavigationHeader from '@alltrails/layout/components/NavigationHeader';
import useMap from '@alltrails/maps/hooks/useMap';
import useAlgoliaResultSelect from '@/hooks/useAlgoliaResultSelect';

type ExploreNavigationBaseProps = ComponentProps<typeof NavigationHeader>;

const ExploreNavigationBase = (navigationHeaderProps: ExploreNavigationBaseProps) => {
  const map = useMap();
  const getMapLatLng = useMemo(() => {
    if (map) {
      return () => map.getCenter();
    }
    return undefined;
  }, [map]);

  const handleResultSelect = useAlgoliaResultSelect({ navigateToPOI: true, navigateToPlace: true, navigateToTrail: true });

  return (
    <NavigationHeader
      edgeToEdge
      searchClearOnSelect
      searchPreventNavigationOnSelect
      searchGetCurrentLatLng={getMapLatLng}
      searchOnResultSelect={handleResultSelect}
      {...navigationHeaderProps}
    />
  );
};

export default ExploreNavigationBase;
